export default function CTA() {
  return (
    <section className="py-24 bg-[#FFE8DC]">
      <div className="max-w-4xl mx-auto px-6 text-center">
        {/* Text Content */}
        <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 leading-tight">
          ティーンエイジャーに、<br />セラピーという選択肢を
        </h2>
        
        <p className="text-lg text-gray-700 mb-10 leading-relaxed">
          健康な時はもっと深く自分を見つめ、<br />
          悩んでいる時は少しでも楽になるために
        </p>

        <button 
          onClick={() => document.getElementById('booking')?.scrollIntoView({ behavior: 'smooth' })}
          className="bg-[#6B4E3D] hover:bg-[#5A3F2E] text-white px-10 py-4 rounded-full text-base font-medium transition-all shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
        >
          初回セッションを予約 →
        </button>

        {/* Bottom Illustration */}
        <div className="mt-16 flex items-center justify-center gap-12 opacity-60">
          <div className="text-5xl">💚</div>
          <div className="text-5xl">🌿</div>
          <div className="text-5xl">📖</div>
          <div className="text-5xl">☕</div>
        </div>
      </div>
    </section>
  );
}
